<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <h1>Movement Type Details</h1>
        <v-row>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Code"
              :class="classPadding"
              v-model="mt.reasonCode"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-text-field
              label="Description"
              :class="classPadding"
              v-model="mt.reasonDesc"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-checkbox
              label="With Salary"
              :class="classPadding"
              v-model="mt.withAgreedSal"
              v-if="this.genConfig.sapInfoTypesIntegration"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>
      <router-view />
    </v-container>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import List from "./List";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/movementTypeDetails";
export default {
  metaInfo: {
    title: "Movement Type Details",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  mixins: [userAccessMixin],
  components: {
    List,
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    mt: {},
    componentKey: 0,
  }),
  computed: {
    ...mapState("config", {
      genConfig: (state) => state.genConfig,
    }),
  },
  methods: {
    ...mapActions("config", ["getGenConfig"]),
    ...mapActions("movementTypeDetails", ["selectMovementTypeDetails"]),
    save() {
      this.isSaving = true;

      this.$axios
        .post(`${API_ENDPOINT}`, this.mt)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      this.selectMovementTypeDetails(Object.assign({}, item));
      this.$router.push(`/movement-type-details/edit/${item.reasonCode}`);
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete",
      }).then((res) => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.reasonCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.mt = {};
      this.forceRerender();
    },
    forceRerender() {
      this.componentKey += 1;
    },
  },
  watch: {
    $route(val) {
      if (val.name === "movement-type-details") {
        this.forceRerender();
      }
    },
  },
  created() {
    this.getGenConfig();
    this.getUserAccessRights("ResonLeav");
  },
};
</script>
